module.exports = __webpack_public_path__ + "static/group-chat-38ad2c41c32b4af9c0ec4f73e4d92e15.png";